// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const cetoddle: PokeData = {
  "id": 974,
  "name": "cetoddle",
  "height": 12,
  "weight": 450,
  "base_experience": 67,
  "types": [
    PokeType.ICE
  ],
  "api_moves": [
    "tackle",
    "body-slam",
    "take-down",
    "double-edge",
    "growl",
    "blizzard",
    "amnesia",
    "rest",
    "flail",
    "powder-snow",
    "bounce",
    "avalanche",
    "ice-shard",
    "echoed-voice",
    "ice-spinner"
  ],
  "moves": [
    "tackle",
    "body-slam",
    "growl",
    "blizzard",
    "avalanche",
    "ice-shard",
    "ice-fang",
    "ice-punch",
    "hailstorm",
    "ice-wave",
    "chilly-reception",
    "aurora-veil",
    "sheer-cold"
  ],
  "evolution_chain": {
    "id": 511,
    "item": null,
    "species": [
      {
        "name": "cetoddle",
        "order": 947,
        "types": [
          PokeType.ICE
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "cetitan",
        "order": 948,
        "types": [
          PokeType.ICE
        ],
        "evolves_from_species_id": 974,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": {
              "name": "ice-stone"
            },
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.USE_ITEM
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 75.25,
    "speed": 43,
    "ability_power": 68
  },
  "stat_changes": [],
  "catch_rate": 150,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
